



























import Vue from 'vue';
import Helpers from '../mixins/helpers';
import IconList from '@/components/dumb/IconList.vue';
import { mapState } from 'vuex';

declare const require: any

export default Vue.extend({
	name: 'CarDetails', 
	props: {
		headingLevel: Number, 
		hideImage: Boolean,
		hideTitle: Boolean, 
		hideBullets: Boolean
	},
	components: {
		IconList
	}, 
	computed: {
		...mapState({
			vehicle(): any {
				return this.$store.state.vehicle;
			}, 
			vehicleImage(): string {
				return this.vehicle.imagesHero.side;
			}
		}),
		vehicleYear(): string {
			const vArray = this.vehicle.produced.split('-');
			return vArray.length ? vArray[0] : ''
		}, 
		vehicleInclOption(): string {
			const o = this.vehicle.inclOption.toLowerCase().includes('with') ? this.vehicle.inclOption : 'With ' + this.vehicle.inclOption;
			return this.vehicle.inclOption ? o : '';
		}, 
		level(): number {
			return this.headingLevel || 2;
		},
		iconItems(): Array<any> {
			const mLength = this.vehicle.materialCode.length;
			const code = this.vehicle.materialCode.substring(mLength - 3);
			const trimCode = this.vehicle.materialCode.substring(mLength - 7, mLength - 3);

			return [
				{
					image: require('@/assets/icon-pump.svg'),
					text: this.vehicle.fuel
				},
				{
					image: require('@/assets/icon-gearstick.svg'),
					text: this.vehicle.transmission
				},
				{
					image: require('@/assets/icon-paint.svg'),
					text: this.vehicle.paintName
				},
				{
					image: require('@/assets/icon-trim.svg'),
					text: this.vehicle.trimName
				}
			];
		}
	}, 
	methods: {
		getColour(){
			return Helpers.getColour(this.vehicle);
		}
	}
});
